import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { medianAggregate } from '../../utils';

const ScaleWrapper = styled.div`
  border-radius: 0.25rem;
  background-color: ${props => props.theme.palette.gray.main};
  display: flex;
  height: 8px;
  overflow: hidden;
  position: relative;
  width: 80px;
  z-index: 0;

  span {
    border-right: 0.12rem solid #fff;
    display: inline-block;
    height: 0.5rem;
    z-index: 5;
    width: 20%;
  }
`;

const Scale = styled.div<{
  value: number;
  reversed: boolean;
}>`
  background-color: ${({ value, reversed }) => {
    if (reversed) {
      if (value <= 1) return '#27AE60';
      if (value <= 2) return '#ebd757';
      if (value <= 3) return '#eb9757';
      if (value <= 4) return '#EB5757';
      return '#ab2b2b';
    }
    if (value <= 1) return '#ab2b2b';
    if (value <= 2) return '#EB5757';
    if (value <= 3) return '#eb9757';
    if (value <= 4) return '#ebd757';
    return '#27AE60';
  }};
  position: absolute;
  left: 0;
  top: 0;
  z-index: 3;
  height: 0.5rem;
  width: ${({ value }) => value * 20}%;
`;

export function generateScaleAggregate(minBound, maxBound) {
  return vals => {
    const median = medianAggregate(vals);
    /*let median = vals[0] || 0;
    vals.forEach(value => {
      median = Math.max(median, value);
    });*/

    if (median === -1) return 5;
    if (!median) return 0;
    if (median / 100 > 1) {
      return 5;
    }
    return ((median - minBound) / maxBound) * 5;
  };
}

export function scaleAggregate(vals) {
  let max = vals[0] || 0;

  vals.forEach(value => {
    max = Math.max(max, value);
  });

  if (max / 100 > 1) {
    return 5;
  }
  if (!max) return 0;
  if (max === -1) return 5;
  return (max / 100) * 5;
}

function ScaleValue({ value, reversed = false }) {
  return (
    <ScaleWrapper>
      <span />
      <span />
      <span />
      <span />
      <Scale value={value} reversed={reversed} />
    </ScaleWrapper>
  );
}

ScaleValue.propTypes = {
  value: PropTypes.number.isRequired,
  reversed: PropTypes.bool,
};

export default ScaleValue;
